//#region src/bite_log_stripe_event.ts
var BiteLogStripeEvent = /* @__PURE__ */ function(BiteLogStripeEvent) {
	BiteLogStripeEvent[BiteLogStripeEvent["None"] = 0] = "None";
	BiteLogStripeEvent[BiteLogStripeEvent["PaymentIntent"] = 1] = "PaymentIntent";
	BiteLogStripeEvent[BiteLogStripeEvent["PaymentIntentError"] = 2] = "PaymentIntentError";
	BiteLogStripeEvent[BiteLogStripeEvent["Refund"] = 3] = "Refund";
	BiteLogStripeEvent[BiteLogStripeEvent["RefundError"] = 4] = "RefundError";
	BiteLogStripeEvent[BiteLogStripeEvent["TokenizationError"] = 5] = "TokenizationError";
	BiteLogStripeEvent[BiteLogStripeEvent["TerminalDisconnected"] = 6] = "TerminalDisconnected";
	return BiteLogStripeEvent;
}(BiteLogStripeEvent || {});
//#endregion
export { BiteLogStripeEvent };

//# sourceMappingURL=bite_log_stripe_event.js.map